import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IntegrationsUrlParamsModel } from '../../../../models/integrations-url-params.model';

@Injectable()
export abstract class EditableTableService {
	/**
	 * Get Data
	 */
	abstract getData(integrationParams: IntegrationsUrlParamsModel): Observable<any>

	/**
	 * Get Data
	 */
	abstract saveData(integrationParams: IntegrationsUrlParamsModel, payload: any[]): Observable<any>

	/**
	 * Save Data using post
	 */
	abstract savePostData(integrationParams: IntegrationsUrlParamsModel, payload: any[]): Observable<any>

	/**
	 * Event to delete elements one by one
	 */
	abstract deleteModel(integrationParams: IntegrationsUrlParamsModel, payload: any): Observable<any>
}
